var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTextDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 793.55 130.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f79535;}.cls-2{fill:#faa739;}.cls-3{fill:#fdb937;}.cls-4{fill:#f27537;}.cls-5{fill:#f58235;}.cls-6{fill:#6f6f6f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo-tekst-licht") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    d: "M19,65.06A44.07,44.07,0,0,1,32.3,33.46a54.34,54.34,0,0,1,78-11A52.39,52.39,0,0,0,20.15,75.23,44.3,44.3,0,0,1,19,65.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-2",
    d: "M128.89,65.06a52.38,52.38,0,0,0-88.63-37.8,44.08,44.08,0,0,1,43.32-1.39,54.37,54.37,0,0,1,34.71,70.78A52,52,0,0,0,128.89,65.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-3",
    d: "M91.82,31.44a44.1,44.1,0,0,1,15.56,33.62,43.43,43.43,0,0,1-.64,7.44c0,.13,0,.27,0,.41a54.44,54.44,0,0,1-54.39,54.38c-.75,0-1.51,0-2.27-.05a51.92,51.92,0,0,0,17.19,2.89A52.4,52.4,0,0,0,91.82,31.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M69.39,108.83a53.63,53.63,0,0,1-17,2.77A54.72,54.72,0,0,1,0,71.92c0,.33,0,.66,0,1a52.37,52.37,0,0,0,103.89,9.37A44.34,44.34,0,0,1,69.39,108.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-5",
    d: "M23.53,84.61A54.34,54.34,0,0,1,37.17,7.08a52.38,52.38,0,0,0,22.33,102A44.26,44.26,0,0,1,23.53,84.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M580.81,28.92a35.9,35.9,0,1,1-35.79,36A35.82,35.82,0,0,1,580.81,28.92Zm0,55.84A19.95,19.95,0,1,0,561,64.91,20,20,0,0,0,580.81,84.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M460.09,32.31a1.74,1.74,0,0,1,1.79-2.39h11.67a2.06,2.06,0,0,1,1.79,1.39L483.92,65h.39L499.77,31a1.9,1.9,0,0,1,1.69-1.1h1.8A1.69,1.69,0,0,1,505,31L520.41,65h.4l8.57-33.73a2.06,2.06,0,0,1,1.8-1.39h11.66a1.74,1.74,0,0,1,1.8,2.39L525.79,98.82a1.92,1.92,0,0,1-1.79,1.4h-1.6a2,2,0,0,1-1.69-1.1l-18.25-39.6h-.3L484,99.12a2,2,0,0,1-1.7,1.1h-1.59a1.92,1.92,0,0,1-1.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M624.09,31.81A1.89,1.89,0,0,1,626,29.92h29.81a21.68,21.68,0,0,1,21.74,21.54c0,9.17-6.08,16.55-14.76,20l13.66,25.32a1.88,1.88,0,0,1-1.69,2.89H661.48a1.86,1.86,0,0,1-1.6-.89L646.62,72.39h-6.88V97.82a2,2,0,0,1-1.89,1.89H626a1.89,1.89,0,0,1-1.89-1.89ZM654.5,59.73c4.09,0,7.58-3.79,7.58-8a7.64,7.64,0,0,0-7.58-7.57H639.74V59.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_4",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M686.05,32.31a2.36,2.36,0,0,1,2.39-2.39h11.67a2.43,2.43,0,0,1,2.39,2.39V58.53l22.13-27.61a3,3,0,0,1,1.9-1h12.56a2.31,2.31,0,0,1,1.8,3.69L717.56,62.82,743,95.92a2.34,2.34,0,0,1-1.89,3.69H727.33a2.74,2.74,0,0,1-1.8-.7l-23-31.3V97.32a2.42,2.42,0,0,1-2.39,2.39H688.44a2.36,2.36,0,0,1-2.39-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_5",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M747.08,90.24,751.77,82a2.57,2.57,0,0,1,3.39-.6c.4.2,7.58,5.48,14.16,5.48,4,0,6.88-2.49,6.88-6,0-4.19-3.49-7.38-10.27-10.07-8.58-3.39-19.34-10.07-19.34-22,0-9.87,7.67-19.84,23-19.84C780,28.92,788,34.21,791,36.4c1.19.7,1,2.49.59,3.19l-5.08,7.68c-.7,1.09-2.49,2-3.39,1.29-.9-.49-8.18-6-14.26-6-3.59,0-6.28,2.39-6.28,5.09,0,3.69,3,6.48,10.87,9.67s20.14,9.17,20.14,22.73c0,10.27-8.88,20.64-23.53,20.64-13,0-20.14-5.38-22.44-7.68C746.59,92,746.29,91.64,747.08,90.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_6",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M164.35,90.14c.9-1.3,1.7-2.79,2.59-4.09s2.3-1.69,3.39-.8c.6.5,8.28,6.88,16,6.88,6.88,0,11.26-4.18,11.26-9.27,0-6-5.18-9.77-15.05-13.86-10.17-4.28-18.15-9.57-18.15-21.13,0-7.78,6-18.45,21.84-18.45a33.76,33.76,0,0,1,18.44,5.88,2.37,2.37,0,0,1,.6,3.39c-.8,1.2-1.7,2.59-2.49,3.79s-2.1,1.9-3.49,1c-.7-.4-7.68-5-13.46-5-8.38,0-11.27,5.29-11.27,9,0,5.68,4.39,9.17,12.66,12.56,11.57,4.69,21.44,10.17,21.44,22.33,0,10.37-9.27,18.85-22.23,18.85A32.24,32.24,0,0,1,165,93.33C164.05,92.53,163.35,91.83,164.35,90.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_7",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M232,39.79H215.7a1.9,1.9,0,0,1-1.9-1.9V32.31a1.89,1.89,0,0,1,1.9-1.89h42.87a1.88,1.88,0,0,1,1.89,1.89v5.58a1.89,1.89,0,0,1-1.89,1.9H242.32V98.32a2,2,0,0,1-1.9,1.89h-6.58A2,2,0,0,1,232,98.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_8",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M269.64,32.31a2,2,0,0,1,1.89-1.89h6.68a1.89,1.89,0,0,1,1.9,1.89V73.49c0,10,6.38,17.75,16.55,17.75s16.75-7.68,16.75-17.55V32.31a1.89,1.89,0,0,1,1.89-1.89H322a2,2,0,0,1,1.9,1.89V74.19c0,15.15-11.47,27-27.22,27s-27-11.87-27-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_9",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M336.79,32.31a1.87,1.87,0,0,1,1.8-1.89h22.93a34.9,34.9,0,1,1,0,69.79H338.59a1.88,1.88,0,0,1-1.8-1.89Zm23.33,58.43c14.66,0,25.33-10.77,25.33-25.53s-10.67-25.32-25.33-25.32H347V90.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_10",
    "data-name": "<Compound Path>",
    className: "cls-6",
    d: "M418.39,66.61l-23.33-33.3a1.85,1.85,0,0,1,1.6-2.89H404a2,2,0,0,1,1.59.89l18.05,25.43,18.05-25.43a2.14,2.14,0,0,1,1.59-.89h7.48a1.84,1.84,0,0,1,1.59,2.89l-23.63,33.2V98.32a2,2,0,0,1-1.89,1.89h-6.58a1.9,1.9,0,0,1-1.9-1.89Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextDark);
export default __webpack_public_path__ + "static/media/logo-text-dark.1610fa94844c859623871d0ef091a08e.svg";
export { ForwardRef as ReactComponent };